<template>
  <div class="youtube-video">
    <v-container class="py-6">
      <v-row v-if="youtubeVideos.length > 0">
        <v-col
          v-for="video in youtubeVideos"
          :key="video.videoId"
          cols="12"
          :md="isSmAndDown ? 12 : 4"
        >
          <div class="video-wrapper">
            <iframe
              class="youtube-iframe"
              :src="video.embedSrc"
              :title="video.title"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "YoutubeVideo",
  props: {
    fdinCarousels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      youtubeVideos: [],
      staticYoutubeLinks: [
        "https://youtu.be/bdP7ZyY76MQ?si=J7aygh9xmOni7sKZ",
        "https://youtu.be/LOyMYmj-B04?si=41_AB69s6HOPd6G0",
        "https://youtu.be/CLdEHc8aRcs?si=fOu49pWcZxjg7v0S",
      ],
    };
  },
  computed: {
    isSmAndDown() {
      if (!this.$vuetify || !this.$vuetify.breakpoint) {
        return false;
      }
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.youtubeVideos = this.staticYoutubeLinks
      .map((link, index) => ({
        videoId: this.extractYoutubeVideoId(link),
        embedSrc: this.buildYoutubeEmbedSrc(link),
        title: `Video ${index + 1}`,
      }))
      .filter((item) => item.embedSrc);
  },
  methods: {
    parseYoutubeStartTime(raw) {
      if (!raw) return "";

      const val = raw.toString().trim();
      if (!val) return "";
      if (val.includes("start=")) return `?${val.replace("?", "")}`;

      if (val.includes("t=")) {
        const tPart = val.split("t=")[1];
        let seconds = 0;

        const minMatch = tPart.match(/(\d+)m/);
        const secMatch = tPart.match(/(\d+)s/);

        if (minMatch) seconds += parseInt(minMatch[1], 10) * 60;
        if (secMatch) seconds += parseInt(secMatch[1], 10);

        if (!minMatch && !secMatch && /^\d+$/.test(tPart)) {
          seconds = parseInt(tPart, 10);
        }

        return `?start=${seconds}`;
      }

      return "";
    },
    normalizeYoutubeKey(raw) {
      const val = (raw || "").toString().trim();
      if (!val) return "";

      if (!val.includes("?") && val.includes("&t=")) {
        const [id, tPart] = val.split("&t=");
        return `${id}?t=${tPart}`;
      }

      try {
        if (val.startsWith("http")) {
          const url = new URL(val);

          if (url.hostname.includes("youtu.be")) {
            const id = url.pathname.replace("/", "");
            const t = url.searchParams.get("t");
            return t ? `${id}?t=${t}` : id;
          }

          const v = url.searchParams.get("v");
          if (v) {
            const t = url.searchParams.get("t");
            return t ? `${v}?t=${t}` : v;
          }
        }
      } catch {
        return val;
      }

      return val;
    },
    extractYoutubeVideoId(raw) {
      const key = this.normalizeYoutubeKey(raw);
      if (!key) return "";

      const [idPart] = key.split("?");
      return idPart || "";
    },
    buildYoutubeEmbedSrc(rawKey) {
      const key = this.normalizeYoutubeKey(rawKey);
      if (!key) return "";

      const [idPart, queryPart] = key.split("?");
      const startParam = this.parseYoutubeStartTime(queryPart);
      return `https://www.youtube.com/embed/${idPart}${startParam}`;
    },
  },
};
</script>

<style scoped>
.video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  overflow: hidden;
  border-radius: 12px;
}

.youtube-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
